import { useEffect, useState } from "react";
import { getReportingType } from "helpers";

const defaultFormData = {
  institution_id: "",
  period: "",
  staffs: [],
  reporting_type: "",
};

const defaultErrors = {
  institution_id: "",
  period: [],
  staffs: [],
  reporting_type: [],
};

export const useFormState = (existingConfig) => {

  const [selectedOptions, setSelectedOptions] = useState({
    institution: null,
    period: null,
    staff: [],
    type: [],
  })

  const [formData, setFormData] = useState(defaultFormData);

  const setSelectedOptionsFn = (existingConfig) => {
    if (existingConfig) {
      setSelectedOptions({
        institution: existingConfig.institution_targeted_id
          ? {
              value: existingConfig.institution_targeted.id,
              label: existingConfig.institution_targeted.name,
            }
          : null,
        period: existingConfig.period_tag,
        staff: existingConfig.selectedStaffs,
        type: {
          value: existingConfig.reporting_type,
          label: existingConfig.reporting_type,
        }
      });
    }
  }

  const setFormDataFn = (existingConfig) => {
    if (existingConfig) {
      const selectedStaffIds = existingConfig.selectedStaffs.map(
        (staff) => staff.id
      );
      setFormData({
        reporting_type: existingConfig.reporting_type,
        staffs: selectedStaffIds,
        period: existingConfig.period,
      });
    }
  }
  
  useEffect(() => {
    if (existingConfig) {
      setSelectedOptionsFn(existingConfig);
      setFormDataFn(existingConfig);
    }
  }, [existingConfig]);

  const [errors, setErrors] = useState(defaultErrors);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateFormData = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const updateSelectedOption = (field, value) => {
    setSelectedOptions((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setFormData(defaultFormData);
    setSelectedOptions({
      institution: null,
      period: null,
      staff: [],
      type: null,
    });
    setErrors(defaultErrors);
  };

  return {
    formData,
    errors,
    setErrors,
    isSubmitting,
    setIsSubmitting,
    selectedOptions,
    updateFormData,
    updateSelectedOption,
    resetForm,
  };
};
